import React, { useEffect, useState } from "react";
import { Mail, MailOpen } from "lucide-react";
import api from "@/lib/api";

export default function InboxPage() {
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(null);

  const load = () => api.get("/inbox").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    setOpenId(openId === m.id ? null : m.id);
    if (!m.read) {
      await api.post(`/inbox/${m.id}/read`);
      setItems((prev) => prev.map((x) => (x.id === m.id ? { ...x, read: true } : x)));
    }
  };

  return (
    <div data-testid="inbox-page">
      <p className="vw-label">Inbox</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-white mt-1 mb-6">Messages</h1>

      {items === null ? (
        <div className="h-32 rounded-2xl bg-slate-800/50 animate-pulse" />
      ) : items.length === 0 ? (
        <div className="vw-card p-10 text-center">
          <Mail className="mx-auto text-slate-600 mb-3" size={32} />
          <p className="text-slate-400">Your inbox is empty.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <button key={m.id} onClick={() => open(m)} className="w-full text-left vw-card p-5 hover:border-emerald-500/40 transition-colors" data-testid={`inbox-item-${m.id}`}>
              <div className="flex items-start gap-3">
                <div className={`h-10 w-10 grid place-items-center rounded-xl shrink-0 ${m.read ? "bg-slate-800 text-slate-500" : "bg-emerald-500/15 text-emerald-400"}`}>
                  {m.read ? <MailOpen size={18} /> : <Mail size={18} />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <span className={`font-semibold ${m.read ? "text-slate-300" : "text-white"}`}>{m.title}</span>
                    {!m.read && <span className="h-2 w-2 rounded-full bg-emerald-400 shrink-0" />}
                  </div>
                  <span className="text-xs text-slate-500 font-mono">{new Date(m.created_at).toLocaleString()}</span>
                  <p className={`mt-2 text-sm text-slate-400 ${openId === m.id ? "" : "line-clamp-1"}`}>{m.content}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
